import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsSatisfactionTimeScaleRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-satisfaction-time-scale',
	path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId',
};
